
import {ReviewWord} from "./reports.objects";
import {RecordingBadge} from "../services/usermodel/usermodel.objects";
export class PreviewReportItems  {
    public type:string = "preview";
    public title:string = "Step 1: Preview & Read";
    public highestScore:string;// = "First Score " + this.report.preview.correctCount + "/" + sd.taqCount;
    public goal:number;
    public point:number;

    constructor(private correctCount:number, private taqCount:number, private pointScore:number, public hasStar: boolean) {
        this.highestScore = "First Score: " + correctCount + "/" + taqCount;
        this.point = pointScore;
        this.goal = taqCount * 5;
    }
}

export class FluencyReportItems {
    public type: string = "record";
    public highestWCPM: string;
    public wcpmTarget: string;
    public goal: number;
    public point: number;

    constructor(public highestWcpm: number, public fluencyGoal: number, private pointScore: number, public reviewWords: ReviewWord[],
                public recordingBadge: RecordingBadge) {
        this.highestWCPM = "Best Initial WCPM: " + highestWcpm;
        this.wcpmTarget = "WCPM Target: " + fluencyGoal;
        this.goal = 100;
        this.point = pointScore;
    }
}

export class QuizReportItems {
    public type: string = "quiz";
    public highestScore: string;
    public currentScore: string;
    public goal: number;
    public point: number;
    public hasStar: boolean;

    constructor(private firstCorrectCount: number, private quizCount: number, private pointScore: number, private star: boolean) {
        this.highestScore = "First Score: " + firstCorrectCount + "/" + quizCount
        this.goal = quizCount * 10;
        this.point = pointScore;
        this.hasStar = star;
    }
}
